<template>
    <div>
        <vue-dropzone
                ref="myVueDropzone"
                id="dropzone"
                :options="dropzoneOptions"
                v-on:vdropzone-error="error"
                class="dropzone dropzone-default dropzone-primary dz-clickable"
                :useCustomSlot=true
        >
            <div class="dropzone-custom-content pb-1">
                <button type="button" class="dropzone-select btn btn-label-info btn-bold btn-sm dz-clickable" v-if="nombre===null">
                    <i class="fa fa-file"></i> Examinar
                </button>
                <button type="button" class="dropzone-select btn btn-label-danger btn-bold btn-sm dz-clickable" v-else>
                    <i class="fa fa-undo"></i> Remplazar
                </button>
            </div>
        </vue-dropzone>
    </div>

</template>

<script>
    import vue2Dropzone from 'vue2-dropzone';
    export default {
        name: "boton-file",
        data(){
            const vm=this;
            return {
            dropzoneOptions: {
                url: '/',
                maxFilesize: 1.5,
                maxFiles:1,
                acceptedFiles:"image/*,application/pdf",
                uploadMultiple: false,
                autoProcessQueue: false,
                thumbnailWidth: 200,
                addRemoveLinks: false,
                accept: function(file, done){
                    // const reader = new FileReader();
                    // reader.readAsDataURL(file);
                    vm.exito(file);
                    done();
                },
                dictDefaultMessage: "Suelta archivos aquí para subir",
                dictFallbackMessage: "Su navegador no admite la carga de archivos de arrastrar y soltar.",
                dictFallbackText: "Utilice el formulario de reserva a continuación para cargar sus archivos como en los viejos tiempos.",
                dictFileTooBig: "El archivo es demasiado grande ({{filesize}} MB). Tamaño máximo de archivo: {{maxFilesize}} MB.",
                dictInvalidFileType: "No puedes subir archivos de este tipo.",
                dictResponseError: "El servidor respondió con el código {{statusCode}}.",
                dictCancelUpload: "Cancelar carga",
                dictUploadCanceled: "Subida cancelada",
                dictCancelUploadConfirmation: "¿Estás seguro de que deseas cancelar esta carga?",
                dictRemoveFile: "Eliminar archivo",
                dictRemoveFileConfirmation: "Quieres eliminar el archivo",
                dictMaxFilesExceeded: "No puede cargar más archivos.",
                init: function() {
                    this.on("maxfilesexceeded", function(file) {
                        this.removeAllFiles();
                        this.addFile(file);
                    });
                },
            },
            nombre:null,
            ext:null,
        }},
        components:{
            vueDropzone: vue2Dropzone
        },
        props:["value"],
        watch:{
            value:function(valor){
                if(valor===null){
                    this.nombre=null;
                    this.ext=null;
                    this.$emit('input', null);
                }
            }
        },
        methods:{
            exito:function(file){
                const reader = new FileReader();
                const vm = this;
                reader.readAsDataURL(file);
                reader.onloadend = function() {
                    vm.nombre=file.name;
                    vm.ext=file.name.split('.').pop().toUpperCase();
                    vm.$emit('input', {base64:reader.result,nombre:file.name,ext:vm.ext});
                }
            },
            error:function(file,message){
                switch (file.status) {
                    case 'canceled':
                        break;
                    case 'error':
                        if(message!==this.dropzoneOptions.dictMaxFilesExceeded)
                            this.$toast.error(message);
                        else
                            this.$toast.info("Se ha remplazado "+this.nombre);
                        this.$refs.myVueDropzone.removeAllFiles();
                        break;
                    default:
                        this.$refs.myVueDropzone.removeAllFiles();
                        break;
                }
                this.nombre=null;
                this.ext=null;
                this.$emit('input', null);
            },
            limpiar:function(){
                this.$refs.myVueDropzone.removeAllFiles();
            }
        }
    }
</script>

<style scoped>

</style>
